// extracted by mini-css-extract-plugin
export var label = "_g7-2";
export var slideContainer = "_g7-0";
export var slider = "_g7-1";